export default "__VITE_ASSET__BqZ_9u6s__"